import { calculateScore } from './calculateScore';

const setLeaderBoard = (quizPlays) => {
  const playsWithScores = quizPlays.map(play => ({
    ...play,
    score: calculateScore(play.quiz_duration, play.total_correct, play.total_incorrect),
  }));

  playsWithScores.sort((a, b) => b.score - a.score);

  // Filter to keep highest score for each play_email
  const highestScoresPerRegistrant = playsWithScores.reduce((acc, play) => {
    const key = play.play_email;
    if (!acc[key] || acc[key].score < play.score) {
      acc[key] = play;
    }
    return acc;
  }, {});

  const filteredPlaysWithScores = Object.values(highestScoresPerRegistrant);

  const groupedByScore = filteredPlaysWithScores.reduce((acc, play) => {
    const score = play.score;
    if (!acc[score]) {
      acc[score] = [];
    }
    acc[score].push(play);
    return acc;
  }, {});

  const topScores = Object.entries(groupedByScore)
    .sort((a, b) => Number(b[0]) - Number(a[0]))
    .slice(0, 10)
    .map(([_, users]) => users);

  return topScores;
};

export default setLeaderBoard;